import styled from 'styled-components';
import { Form, Table } from 'react-bootstrap';

export const FormWrapper = styled(Form)`
    margin-bottom: 20px;

    .row-underlined {
        border-bottom: .5px solid #cccccc; /* Change the color as needed */
        padding-bottom: 5px; /* Adjust as needed to control the space between text and underline */
        margin-bottom: 10px; /* Adjust as needed to control the space below the underline */
    }

    .form-group-spacing {
        margin-bottom: 10px;
    }

    & > .form-group {
        min-height: 70px;
    }

    & > .form-group:nth-child(odd) {
        background-color: #f9f9f9;
    }

    .row {
        margin-bottom: 5px;
    }

    .row-value-center > .col-sm-4:nth-child(2),
    .row-value-center > .col-sm-4:nth-child(4) {
        text-align: center;
    }

    .row-value-right > .col-sm-2:nth-child(2),
    .row-value-right > .col-sm-3:nth-child(2),
    .row-value-right > .col-sm-2:nth-child(4) {
        text-align: right;
    }
`;

export const TableWrapper = styled(Table)`
    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;